import ProfilePage from './profile';

export default ProfilePage;
